import featureSupportConfig from './feature/support'

const supportConfig = {
  chatLocales: featureSupportConfig.chat.askUsAnything.locales,
  communityLinks: featureSupportConfig.help.communityUrls,
  reportAbuse: {
    sessionSubject: 'Report Abuse for Session',
    eventName: 'RootsTech',
  },
}

export default supportConfig
